import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { IPreInrolatAddPayload, IPreInrolatEditPayload } from '../pre-enrolled-accounts.interface';
import { PreEnrolledAccountsService } from '../pre-enrolled-accounts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-edit-pre-inrolat',
    templateUrl: './edit-pre-inrolat.component.html',
    styleUrls: ['./edit-pre-inrolat.component.scss']
})
export class EditPreInrolatComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        persoana_id: new FormControl(this.data.persoana_id, []),
        nume: new FormControl(this.data.nume, [Validators.required]),
        prenume: new FormControl(this.data.prenume, [Validators.required]),
        telefon: new FormControl(this.data.telefon, [Validators.required]),
        email: new FormControl(this.data.email, [Validators.required]),
        cnp: new FormControl(this.data.cnp, []),
        cui: new FormControl(this.data.cui, []),
        // active: new FormControl(this.data.active, []),
        // confirmed: new FormControl(this.data.confirmed, []),
        // confirmed_source: new FormControl(this.data.confirmed_source, []),
        // id_cetatean_m: new FormControl(this.data.id_cetatean_m, []),
        pin: new FormControl(this.data.pin, []),
        f_nume: new FormControl(this.data.f_nume, []),
        f_reg_com: new FormControl(this.data.f_reg_com, [])
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IPreInrolatEditPayload,
        private dialogRef: MatDialogRef<EditPreInrolatComponent>,
        private preEnrolledAccountsService: PreEnrolledAccountsService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.preEnrolledAccountsService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const {
            persoana_id,
            nume,
            prenume,
            telefon,
            email,
            cnp,
            cui,
            // active,
            // confirmed,
            // confirmed_source,
            // id_cetatean_m,
            pin,
            f_nume,
            f_reg_com,
        } = this.form.value as IPreInrolatAddPayload;

        const updatedAccount: IPreInrolatEditPayload = {
            id: this.data.id,
            persoana_id,
            nume,
            prenume,
            telefon,
            email,
            cnp,
            cui,
            // active,
            // confirmed,
            // confirmed_source,
            // id_cetatean_m,
            pin,
            f_nume,
            f_reg_com,
        };

        this.preEnrolledAccountsService
            .updatePreInrolat(updatedAccount)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let msg;
            try {
                // try to catch the message from server
                msg = res.error.errors.message[0];
            } catch (error) {
                // controll output message
                msg = helper.dialogConfig.generalMessages.error;
            }
            this.notificationService.warningSwal(
                this.errorTitle,
                msg,
                this.errorIcon
            );
        }
    }
}
